import { render, staticRenderFns } from "./custom-notification.vue?vue&type=template&id=715c3cc4"
import script from "./custom-notification.vue?vue&type=script&lang=js"
export * from "./custom-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports